import apiConsulta from "api/api-consulta";
import {
  Attendance,
  AttendanceFactaFGTS,
  AttendanceMargens,
  ContratoInss,
  ContratoRMCInss,
} from "components/atendimentos-components/atendimento-form/types";
import { openModalConfirm } from "components/modal-confirm-new";
import { openModalError } from "components/modal-error";
import { Dispatch, SetStateAction } from "react";
import { formatData } from "utils/string-formats";
import { getErrorByMessage, mapObject } from "./mapeamentos";
import {
  AttendanceActionsTypes,
  controllerAttendanceRequests,
} from "../../../../contexts/attendance-context/actions-reducer";
import {
  ConsultaOfflineINSS,
  ConsultaOfflineSiape,
  KeyForward,
} from "./mapeamentos/types";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";
import { AxiosResponse } from "axios";
import { openModalConsultaOfflineSelectBenefit } from "components/atendimentos-components/pagina-atendimento/attendance-data-form/modal-consulta-offline-select-benefit";
import {
  ConsultaProps,
  ConsultaPropsNewInterface,
  ContratoCartaoRCCNewInterface,
  ContratoEmprestimoNewInterface,
} from "components/consulta-components/consulta-fields/types";
import { Toast } from "components/toast";

export interface ConsultaOfflineOptions {
  url: string;
  mapFunction: (
    res: any,
    dispatch: Dispatch<AttendanceActionsTypes>,
    attendance: Attendance
  ) => void;
}

interface ConsultaFGTS {
  valorLiberadoAntecipacaoFGTS: number;
  statusSaldo: AttendanceFactaFGTS["statusSaldo"];
  simulacaoAntecipacaoFGTS: Attendance["simulacaoAntecipacaoFactaFGTS"];
}

export function parseContratoINSSEmprestimoNewInterface(
  contract: ContratoEmprestimoNewInterface,
  origem = null
): ContratoInss {
  return {
    codBanco: contract.banco,
    codTipoEmprestimo: contract.tipoEmprestimo,
    contrato: contract.contrato,
    competenciaInicioDesconto: contract.dataInicioDesconto,
    competenciaFimDesconto: contract.dataFimDesconto,
    dataInicioContrato: contract.dataAverbacao,
    id: Math.random() * 100000,
    quantidadeParcelas: contract.prazo,
    quantidadeParcelasEmAberto: contract.parcelasRestantes,
    taxa: contract.taxa ? Number(contract.taxa?.toFixed(2)) : 0,
    saldoQuitacao: contract.saldoDevedor,
    valorParcela: contract.valorParcela,
    valorEmprestado: contract.valorEmprestimo,
    ade: contract.dataAverbacao,
    situacao: "",
    origem: origem,
  };
}
export function parseContratoRMCAndRCCINSSNewInterface(
  contract: ContratoCartaoRCCNewInterface,
  origem = "CONSULTA_OFFLINE",
  isRmc: boolean
): Partial<ContratoRMCInss> {
  return {
    codTipoEmprestimo: isRmc ? "217" : "268",
    codBanco: contract.banco,
    contrato: contract.contrato,
    // competenciaInicioDesconto: contract.,
    // competenciaFimDesconto: contract.dataFimDesconto,
    dataInicioContrato: contract.dataInclusao,
    id: Math.random() * 100000,
    // quantidadeParcelas: contract.,
    // quantidadeParcelasEmAberto: contract.,
    // taxa: contract.,
    // saldoQuitacao: contract.,
    valorReservado: contract.valorParcela,
    limiteCartao: contract.valor,

    // : contract.valorEmprestimo,
    // ade: contract.dataAverbacao,
    // situacao: "",
    // origem: origem,
  };
}

export function parseContratoEmprestimoInss(contract: any): ContratoInss {
  delete contract.excluidoAps;
  delete contract.excluidoBanco;
  delete contract.dataInclusao;
  contract.codTipoEmprestimo = contract.tipoEmprestimo?.codigo;
  contract.codBanco = contract.banco?.codigo;
  return contract;
}

export function parseContratoRMCorRCC(contract: any): ContratoRMCInss {
  contract.codTipoEmprestimo = contract.tipoEmprestimo?.codigo;
  delete contract.tipoEmprestimo;
  contract.codBanco = contract.banco?.codigo;
  delete contract.banco;
  delete contract.excluidoAps;
  delete contract.excluidoBanco;
  return contract;
}

async function requestLoop({
  promise,
  actionByStep,
  onFinish,
  onError,
  delay = 5000,
}: {
  promise: () => Promise<AxiosResponse<any, any>>;
  actionByStep: (response: AxiosResponse<ConsultaFGTS, any>) => {
    finalize: boolean;
  };
  onFinish?: (response: AxiosResponse<any, ConsultaFGTS>) => any;
  onError?: () => any;
  delay?: number;
}) {
  let response: any;
  let finalizeState: any;
  try {
    response = await promise();
    const { finalize } = actionByStep(response);
    finalizeState = finalize;
  } catch (e) {
    onError?.();
  }
  if (!finalizeState) {
    setTimeout(() => requestLoop({ promise, actionByStep, onFinish }), delay);
  } else onFinish?.(response);
}

export async function consultaFGTS({
  loading,
  consultar,
  verificar,
  errorMessage = "Erro ao fazer consulta FGTS",
  isEndLoop,
  onFinish,
}: {
  loading: Dispatch<SetStateAction<boolean>>;
  consultar?: () => Promise<AxiosResponse<any, any>>;
  verificar?: () => Promise<AxiosResponse<any, any>>;
  errorMessage?: string;
  isEndLoop: (response: AxiosResponse<any, any>) => boolean;
  onFinish: (response: AxiosResponse<any, any>) => void;
}) {
  const { signal } = controllerAttendanceRequests;
  loading(true);

  let isStopedConsultation = false;

  signal.addEventListener("abort", () => {
    isStopedConsultation = true;
    loading(false);
  });

  try {
    if (consultar) {
      const res = await consultar();
      const data = res?.data;
      if (data) onFinish(res);
    }

    if (verificar) {
      requestLoop({
        promise: verificar,
        actionByStep: (response) => {
          if (isStopedConsultation) return { finalize: true };
          let finalize = isEndLoop(response);
          return { finalize };
        },
        onFinish: (response) => {
          onFinish(response);
          loading(false);
        },
      });
    }
  } catch (e: any) {
    const requestErrorMessage = e?.response?.data?.msgInterface;
    if (requestErrorMessage) {
      Toast({ title: requestErrorMessage, status: "error" });
    } else if (e?.message !== "canceled") {
      Toast({
        title: errorMessage,
        status: "error",
      });
    }
    loading(false);
  } finally {
    // loading(false);
  }
}

export function mapConsultaFGTS(
  consulta: ConsultaFGTS,
  dispatch: Dispatch<AttendanceActionsTypes>,
  formValues: Attendance
) {
  let atendimentoFactaFGTS = formValues.atendimentoFactaFGTS!;
  const keyForward: KeyForward<Attendance> = {
    valorLiberadoAntecipacaoFGTS: (data) => {
      atendimentoFactaFGTS = {
        ...atendimentoFactaFGTS,
        valorLiberadoAntecipacao: data,
      };
      return {
        data: atendimentoFactaFGTS,
        field: "atendimentoFactaFGTS",
        dispatchOptions: { type: "changeFieldWithInitial" },
      };
    },
    statusSaldo: (data) => {
      atendimentoFactaFGTS = { ...atendimentoFactaFGTS, statusSaldo: data };
      return {
        data: atendimentoFactaFGTS,
        field: "atendimentoFactaFGTS",
        dispatchOptions: { type: "changeFieldWithInitial" },
      };
    },
    observacaoSaldo: (data) => {
      atendimentoFactaFGTS = { ...atendimentoFactaFGTS, observacaoSaldo: data };
      return {
        data: atendimentoFactaFGTS,
        field: "atendimentoFactaFGTS",
        dispatchOptions: { type: "changeFieldWithInitial" },
      };
    },
    simulacaoAntecipacaoFGTS: (data) => {
      return {
        data: data ?? formValues.simulacaoAntecipacaoFactaFGTS,
        field: "simulacaoAntecipacaoFactaFGTS",
        dispatchOptions: { type: "changeFieldWithInitial" },
      };
    },
  };

  dispatch({
    type: "changeFieldWithInitial",
    payload: { data: "FACTA", fieldName: "bancoDigitacao" },
  });

  mapObject({ keyForward, data: consulta, dispatch, ignoreNullFields: false });
}

export function mapConsultaOfflineSIAPE(
  consulta: ConsultaOfflineSiape,
  dispatch: Dispatch<AttendanceActionsTypes>,
  attendance: Attendance
) {
  let margens = attendance.margens! || {};

  const keyForward: KeyForward<Attendance> = {
    AGENCIA_RECEBIMENTO: (data) => {
      if (data != null) {
        data = `${data}`.trim();
        while (data.length < 11) data = "0" + data;
      }
      return {
        data,
        field: "agenciaPagamento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    BAIRRO: (data) => {
      return {
        data,
        field: "bairro",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    BANCO_RECEBIMENTO: (data) => {
      return {
        data,
        field: "codBancoPagamento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    CELULAR_01: (data) => {
      return {
        data,
        field: "telefoneCelular",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    CEP: (data) => {
      return { data, field: "cep", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    CIDADE: (data) => {
      return {
        data,
        field: "cidade",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    COMPLEMENTO: (data) => {
      return {
        data,
        field: "complemento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    CONTA_RECEBIMENTO: (data) => {
      return {
        data,
        field: "contaPagamento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    CPF: (data) => {
      return { data, field: "cpf", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    EMAIL: (data) => {
      return { data, field: "email", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    ENDERECO: (data) => {
      return {
        data,
        field: "endereco",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    // "ESTADO CIVIL": (data) => {
    //   return { data, field: "estadoCivil" };
    // },
    MAE: (data) => {
      return {
        data,
        field: "nomeMae",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    MATRICULA: (data) => {
      return { data, field: "nb", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    NASC: (data?: string) => {
      const [ano, mes, dia] = data?.split("-") || [];
      return {
        data: `${dia}/${mes}/${ano}`,
        field: "dataNascimento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    NOME: (data) => {
      return { data, field: "nome", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    ORGAO: (data) => {
      return {
        data,
        field: "orgaoSIAPE",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    RG: (data) => {
      return {
        data,
        field: "documento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    SEXO: (data) => {
      return { data, field: "sexo", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    UF: (data) => {
      return { data, field: "uf", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    "RESUMO_FINANCEIRO.BASECALC": (data) => {
      return {
        data,
        field: "valorSalario",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "RESUMO_FINANCEIRO.SALDO35": (data) => {
      margens = { ...margens, valorMargemLivreNovo: data };
      return {
        data: margens,
        field: "margens",
        assignJson: {
          attendanceKeyPath: "margens.valorMargemLivreNovo",
          flag: "CONSULTA OFFLINE",
        },
      };
    },
    "RESUMO_FINANCEIRO.SITUACAOFUNCIONAL": (data) => {
      return {
        data,
        field: "situacaoFuncionalSIAPE",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "RESUMO_FINANCEIRO.UPAG": (data) => {
      return {
        data,
        field: "unidadePagadoraSIAPE",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
  };

  mapObject({ keyForward, data: consulta, dispatch });
}

export function mapConsultaOffline(
  consulta: ConsultaPropsNewInterface,
  dispatch: Dispatch<AttendanceActionsTypes>,
  attendance: Attendance
) {
  let margens: Partial<AttendanceMargens> = attendance.margens || {};

  const keyForward: KeyForward<Attendance> = {
    "dadosCadastrais.cpf": (data) => {
      data = completeCPF(data);
      return {
        data,
        field: "cpf",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.nb": (data) => {
      data = completeNB(data);
      return {
        data,
        field: "nb",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.ufBeneficio": (data) => {
      return {
        data,
        field: "ufNB",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.bloqueadoEmprestimo": (data) => {
      return {
        data,
        field: "bloqueadoEmprestimo",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.dataNascimento": (data) => {
      return {
        data: formatData(data),
        field: "dataNascimento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.ddb": (data) => {
      return {
        data: formatData(data),
        field: "ddb",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.nome": (data) => {
      return { data, field: "nome", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    "dadosCadastrais.nomeMae": (data) => {
      return {
        data,
        field: "nomeMae",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.pensaoAlimenticia": (data) => {
      return {
        data,
        field: "pensaoAlimenticia",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.representanteLegal": (data) => {
      return {
        data,
        field: "possuiRepresentante",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosRepresentanteLegal.cpf": (data) => {
      return {
        data,
        field: "cpfRepresentanteLegal",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosRepresentanteLegal.nome": (data) => {
      return {
        data,
        field: "nomeRepresentanteLegal",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.permiteEmprestimo": (data) => {
      return {
        data,
        field: "elegivelEmprestimo",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.sexo": (data: string) => {
      const parseData =
        data?.toUpperCase() === "MASCULINO"
          ? "MASCULINO"
          : data?.toUpperCase() === "FEMININO"
          ? "FEMININO"
          : null;
      return {
        data: parseData,
        field: "sexo",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.situacao": (data) => {
      return {
        data,
        field: "situacaoNB",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosMargens.valorBeneficio": (data) => {
      return {
        data,
        field: "valorSalario",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.bairro": (data) => {
      return {
        data,
        field: "bairro",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.cep": (data) => {
      return { data, field: "cep", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    "dadosCadastrais.cidade": (data) => {
      return {
        data,
        field: "cidade",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.endereco": (data) => {
      return {
        data,
        field: "endereco",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.uf": (data) => {
      return { data, field: "uf", assignJson: { flag: "CONSULTA OFFLINE" } };
    },
    "dadosBancario.banco": (data) => {
      return {
        data,
        field: "codBancoPagamento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosBancario.contaPgto": (data) => {
      return {
        data,
        field: "contaPagamento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosBancario.meioPagamento": (data: string) => {
      const parsedData =
        data === "01"
          ? "CARTAO_MAGNETICO"
          : data === "02"
          ? "CONTA_CORRENTE"
          : null;
      return {
        data: parsedData,
        field: "tipoPagamento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.especie": (data) => {
      data = Number(data);
      return {
        data: isNaN(data) ? null : data,
        field: "especieNB",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosBancario.agencia": (data) => {
      return {
        data,
        field: "agenciaPagamento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    emprestimosRmc: (data: any[]) => {
      let parsedData = null;
      if (data?.length) {
        parsedData = data.map((contract: any) =>
          parseContratoRMCAndRCCINSSNewInterface(
            contract,
            "CONSULTA OFFLINE",
            true
          )
        );
      }
      return {
        data: parsedData,
        field: "contratosRMCInss",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    emprestimosRcc: (data: any[]) => {
      let parsedData = null;
      if (data?.length)
        parsedData = data.map((contract: any) =>
          parseContratoRMCAndRCCINSSNewInterface(
            contract,
            "CONSULTA OFFLINE",
            false
          )
        );
      return {
        data: parsedData,
        field: "contratosRCCInss",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosCadastrais.rg": (data) => {
      const parseData = data?.length > 4 ? data : null;
      return {
        data: parseData,
        field: "documento",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosMargens.possuiCartao": (data) => {
      return {
        data,
        field: "possuiCartaoRmc",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosMargens.qtdEmprestimos": (data) => {
      return {
        data,
        field: "qtdEmprestimos",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
    "dadosMargens.margemDisponivelRmc": (data) => {
      margens = { ...margens, valorMargemCartaoRMC: data };
      return {
        data: margens,
        field: "margens",
        assignJson: {
          attendanceKeyPath: "margens.valorMargemCartaoRMC",
          flag: "CONSULTA OFFLINE",
        },
      };
    },
    "dadosMargens.margemDisponivelRcc": (data) => {
      margens = { ...margens, valorMargemCartaoRCC: data };
      return {
        data: data === 0 ? true : typeof data === "number" ? false : null,
        field: "possuiCartaoBeneficio",
        assignJson: {
          attendanceKeyPath: "possuiCartaoBeneficio",
          flag: "CONSULTA OFFLINE",
        },
      };
    },
    "dadosMargens.margemDisponivelEmprestimo": (data) => {
      const parsedData = typeof data === "number" ? data : null;
      margens = { ...margens, valorMargemLivreNovo: parsedData };
      return {
        data: margens,
        field: "margens",
        assignJson: {
          attendanceKeyPath: "margens.valorMargemLivreNovo",
          flag: "CONSULTA OFFLINE",
        },
      };
    },
    emprestimos: (data: any[]) => {
      const parsedData = data.map((contract: any) =>
        parseContratoINSSEmprestimoNewInterface(contract)
      );
      return {
        data: parsedData,
        field: "contratosEmprestimosInss",
        assignJson: { flag: "CONSULTA OFFLINE" },
      };
    },
  };

  mapObject({ keyForward, data: consulta, dispatch });
}

function completeCPF(value: string) {
  if (value) {
    value = `${value}`.trim();
    while (value.length < 11) value = "0" + value;
  }
  return value;
}

function completeNB(value: string) {
  if (value) {
    value = `${value}`.trim();
    while (value.length < 10) value = "0" + value;
  }
  return value;
}

// const parseData = (data: string | null) => {
//   if (data) {
//     let dia = "";
//     const mes = data.match(/\D\d{2}\D/g)?.[0].replace(/\D/g, "");
//     const ano = data.match(/\d{4}/g)?.[0].replace(/\D/g, "");
//     if (ano && data.indexOf(ano) === 0) {
//       dia = data.match(/\D\d{2}$/g)?.[0].replace(/\D/g, "") || "";
//     } else {
//       dia = data.match(/^\d{2}\D/g)?.[0].replace(/\D/g, "") || "";
//     }
//     return `${dia}/${mes}/${ano}`;
//   }
// };
